import Image, { StaticImageData } from "next/image";

interface PastWorksProps {
  title: string;
  images: StaticImageData[];
}

export const PastWorks = ({ title, images }: PastWorksProps) => {
  return (
    <section className="w-full px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <h2 className="mb-12 text-left text-4xl font-light lg:text-6xl">
        {title}
      </h2>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {images.map((image, index) => (
          <div
            key={index}
            className="relative w-full overflow-hidden pt-[170.5%]"
          >
            <Image
              src={image.src}
              alt={`Image ${index + 1}`}
              fill
              sizes="(max-width: 768px) 50vw, 20vw"
              className="object-cover transition-transform duration-300"
            />
          </div>
        ))}
      </div>
    </section>
  );
};
